var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48.5583 27.4048L0.55835 54.4048L0.558352 0.404785L48.5583 27.4048Z","fill":"white"}));
}

IconPlay.defaultProps = {"width":"49","height":"55","viewBox":"0 0 49 55","fill":"none"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
